import { useFormContext, Controller, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Typography, TextField, IconButton, FormControl } from '@mui/material';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { SCH } from './headerTab.classes';

export const HeaderTab = () => {
    const { control } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        name: 'headers',
        control,
    });

    const { t } = useTranslation();

    const handleAddKeyValue = () => {
        append({ Name: '', Value: '' });
    };

    const handleRemoveKeyValue = (index: number) => {
        remove(index);
    };

    return (
        <Box className={SCH.root} sx={{ width: '600px' }}>
            <Typography sx={{ fontWeight: 'bold', mb: 2 }}>Headers</Typography>
            {fields.map((item, index) => (
                <Box
                    key={item.id}
                    className={SCH.row}
                    data-header-index={index}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 2,
                        mb: 2,
                    }}
                >
                    <Typography sx={{ fontWeight: 'bold', alignSelf: 'center' }}>Key: </Typography>
                    <Controller
                        name={`headers.${index}.Name`}
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                className={SCH.keyInput}
                                variant="outlined"
                                size="small"
                                sx={{ width: '45%' }}
                                placeholder="Key"
                            />
                        )}
                    />
                    <Typography sx={{ fontWeight: 'bold', alignSelf: 'center' }}>Value: </Typography>
                    <Controller
                        name={`headers.${index}.Value`}
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                className={SCH.valueInput}
                                variant="outlined"
                                size="small"
                                sx={{ width: '45%' }}
                                placeholder="Value"
                            />
                        )}
                    />
                    <IconButton
                        className={SCH.removeButton}
                        onClick={() => handleRemoveKeyValue(index)}
                        color="error"
                        sx={{
                            '& .MuiSvgIcon-root': {
                                height: '18px',
                                width: '18px',
                            },
                        }}
                    >
                        <RemoveCircleIcon className={SCH.removeIcon} />
                    </IconButton>
                </Box>
            ))}
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <IconButton
                    className={SCH.addButton}
                    onClick={handleAddKeyValue}
                    color="primary"
                    sx={{
                        '& .MuiSvgIcon-root': {
                            height: '18px',
                            width: '18px',
                        },
                    }}
                >
                    <AddCircleIcon className={SCH.addIcon} />
                </IconButton>
                <Typography
                    className={SCH.addText}
                    onClick={handleAddKeyValue}
                    sx={{ ml: 1, fontWeight: 'bold', cursor: 'pointer' }}
                >
                    {t('scheduleService.addHeaderKeyValue')}
                </Typography>
            </FormControl>
        </Box>
    );
};
